var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breakdance-element-studio-twig-code-helper"},[(_vm.codeForControl)?_c('Copyable',{on:{"onCopy":_vm.close}},[_vm._v(_vm._s(_vm.codeForControl))]):[_vm._v("No code help available for "),_c('code',[_vm._v(_vm._s(_vm.control.options.type))]),_vm._v(" control type")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }